import CONST from "./Constant";
import dayjs from "dayjs";

const INITIAL_STATE = {
    stats: {
        totalPresent: 0,
        totalAbsent: 0,
        totalLate: 0,
        totalLeave: 0,
    },
    list:[],
    selected:{},
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:1,
        total:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            sort_by:'created_at',
            sort_dir:'desc',
        }
    },
    calendar: {
        list: [],
        config: {
            from: 0,
            to: 0,
            lastPage: 1,
            total: 0,
            pagination: {
                page: 0,
                pageSize: 10,
            },
            filters: {
                month: dayjs().format("YYYY-MM"),
                keyword: '',
                sort_by: 'created_at',
                sort_dir: 'desc',
            }
        }
    },
    dirty: false,
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.SET_SELECTED_ITEM:
            return {
                ...state,
                selected: state.list.find(item => item.id === action.payload) || {},
            }
        case CONST.FETCH_ROSTER_STATS_SUCCESS:
            return {
                ...state,
                stats: action.payload.data,
                error: [],
                message: ["Attendance stats loaded successfully"],
                code: action.payload.status,
            }
        case CONST.FETCH_ITEM_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["Attendance loaded successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ITEMS_SUCCESS:
            return action.payload.config.params.paginate === undefined ? {
                ...state,
                list: action.payload.data.data,
                config:  {
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Attendance loaded successfully"],
            } : {
                ...state,
                list: action.payload.data,
                error: [],
                code:action.payload.status,
                message: ["Attendance loaded successfully"],
            }
        case CONST.ADD_ITEM_SUCCESS:
            return {
                ...state,
                list:[...state.list,action.payload.data],
                selected: {},
                error: [],
                message: ["Attendance added successfully"],
                code:action.payload.status,
                dirty: true,
            }
        case CONST.UPDATE_ITEM_SUCCESS:
            const indexU = state.list.findIndex(item => item.id === action.payload.data.id);
            return {
                ...state,
                list: [...state.list.slice(0, indexU), action.payload.data, ...state.list.slice(indexU + 1)],
                selected: action.payload.data,
                error: [],
                message: ["Attendance updated successfully"],
                code:action.payload.status,
                dirty: true,
            }
        case CONST.DELETE_ITEM_SUCCESS:
            return {
                ...state,
                list:state.list.filter(item => item.id !== action.payload.data),
                selected: {},
                error: [],
                message: ["Attendance deleted successfully"],
                code:action.payload.status,
                dirty: true,
            }

        /* Attendance Calendar */
        case CONST.SET_CONFIG_CALENDAR:
            return {
                ...state,
                calendar: {
                    ...state.calendar,
                    config: {
                        ...state.calendar.config,
                        ...action.payload
                    },
                },
            };
        case CONST.FETCH_ROSTER_CALENDAR_SUCCESS:
            return action.payload.config.params.paginate === undefined ? {
                ...state,
                calendar: {
                    ...state.calendar,
                    list: action.payload.data.data,
                    config: {
                        ...state.calendar.config,
                        from: action.payload.data.from,
                        to: action.payload.data.to,
                        lastPage: action.payload.data.last_page,
                        total: action.payload.data.total,
                        pagination: {
                            ...state.calendar.config.pagination,
                            page: action.payload.data.current_page - 1,
                            pageSize: action.payload.data.per_page,
                        },
                    },
                },
                error: [],
                dirty: false,
                code: action.payload.status,
                message: ["Attendance calendar loaded successfully"],
            } : {
                ...state,
                calendar: {
                    ...state.calendar,
                    list: action.payload.data,
                    selected: {},
                },
                dirty: false,
            }
        case CONST.FETCH_ROSTER_STATS_FAILED:
        case CONST.FETCH_ITEM_FAILED:
        case CONST.FETCH_ITEMS_FAILED:
        case CONST.ADD_ITEM_FAILED:
        case CONST.UPDATE_ITEM_FAILED:
        case CONST.DELETE_ITEM_FAILED:
        case CONST.FETCH_ROSTER_CALENDAR_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;